import { render } from "./customer-details-cancel.vue?vue&type=template&id=a21e0cb8"
import script from "./customer-details-cancel.vue?vue&type=script&lang=js"
export * from "./customer-details-cancel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__